import React from 'react'

const InfoModal = ({title,info,onclose}) => {
  return (
    
<div class="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} >
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="staticBackdropLabel">{title}</h1>
        <button type="button" class="btn-close" onClick={onclose}></button>
      </div>
      <div class="modal-body">
       {info}
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" onClick={onclose}>Close</button>
      </div>
    </div>
  </div>
</div>
  )
}

export default InfoModal